import React, { useState } from 'react'
import Heading from 'presentation/shared/components/Heading'
import Container from 'presentation/hospital/components/Container'
import TabsNew, { TabItem } from 'presentation/shared/components/TabsNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import { useFormik } from 'formik'
import { ReactComponent as SearchIcon } from 'presentation/assets/icons/search.svg'
import { ReactComponent as FilterIcon } from 'presentation/assets/icons/filter-icon.svg'
import * as S from './styles'
import DateRange from '@material-ui/icons/DateRange'
import { dateMask } from 'presentation/utils/masks'
import moment from 'moment'
import { dateInputFormat } from 'presentation/utils/date-format'
import TextField from 'presentation/shared/components/TextField'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import Table from 'presentation/shared/components/Table'
import AccordionNew from 'presentation/shared/components/AccordionNew'
import CheckboxNew from 'presentation/shared/components/CheckboxNew'
import { items, tableColumns } from './data'
import TabsArrow from 'presentation/shared/components/TabsArrow'

export default function OrderManagementLayout() {
  const [boxIsOpen, setBoxIsOpen] = useState(false)
  const toggleBoxNotifications = () => {
    setBoxIsOpen(!boxIsOpen)
  }

  const crmoDefaultFilters = {
    start: moment().toISOString(),
    end: moment().add('10', 'minutes').toISOString()
  }

  const [showCalendar, setShowCalendar] = useState<'start' | 'end' | ''>()
  const [dates, setDates] =
    useState<{ start?: string; end?: string; label?: string }>(
      crmoDefaultFilters
    )
  const toggleCalendar = (order: 'start' | 'end') => {
    if (showCalendar === order) {
      setShowCalendar('')
    } else {
      setShowCalendar(order)
    }
  }

  const changeDate = (date: Date) => {
    if (showCalendar === 'start' && !moment(date).isSameOrBefore(dates.end)) {
      return setShowCalendar('')
    } else if (
      showCalendar === 'end' &&
      moment(dates[showCalendar]) &&
      !moment(date).isSameOrAfter(dates.start)
    ) {
      return setShowCalendar('')
    }
    if (showCalendar) {
      setDates({
        ...dates,
        [showCalendar]: date.toISOString(),
        label: 'personalized'
      })
    }
    return setShowCalendar('')
  }

  const formik = useFormik({
    initialValues: {
      patientOrNumberOrder: '',
      doctorName: '',
      healthInsurance: '',
      startDate: '',
      endDate: ''
    },
    onSubmit: async () => {
      console.log('test')
    }
  })

  const tabItems = [
    {
      label: 'Todos os pedidos',
      componentChildren: (
        // disabled: activePendencies?.length === 0 && oldPendencies?.length === 0,
        <></>
      )
    },
    {
      label: 'Análise de pedidos',
      componentChildren: <></>
    },
    {
      label: 'Pedidos com OPME',
      componentChildren: <></>
    },
    {
      label: 'Interações com convênio',
      componentChildren: <></>
    },
    {
      label: 'Finalizados',
      componentChildren: <></>
    }
  ] as TabItem[]

  const tabArrowItems = [
    {
      label: 'Solicitação de pedidos',
      componentChildren: (
        // disabled: activePendencies?.length === 0 && oldPendencies?.length === 0,
        <></>
      )
    },
    {
      label: 'Revisão',
      componentChildren: <></>
    },
    {
      label: 'Pré-agendamento',
      componentChildren: <></>
    }
  ] as TabItem[]

  return (
    <>
      <Container>
        <Heading
          as="h1"
          size="large"
          color="primary"
          style={{ marginBottom: '50px' }}
        >
          Gestão de Pedidos
        </Heading>

        <S.PannelContainer>
          <S.TabWrapper>
            <div style={{ marginBottom: '20px' }}>
              <TabsNew tabItems={tabItems} defaultTab={1} />
            </div>

            {/* <S.ArrowDivContainer>
              <S.ArrowDiv className="first" selected={true}>
                <span>12 Solicitação de pedidos</span>
              </S.ArrowDiv>

              <S.ArrowDiv selected={false}>
                <span> 15 Revisão</span>
              </S.ArrowDiv>

              <S.ArrowDiv selected={false}>
                <span> 17 Pré-agendamento</span>
              </S.ArrowDiv>
            </S.ArrowDivContainer> */}

            <TabsArrow tabItems={tabArrowItems} defaultTab={1} />

            <S.InputWrapper>
              <TextFieldNew
                placeholder="Paciente, ou N° do aviso"
                style={{ maxWidth: '500px' }}
                name="patientOrNumberOrder"
                value={formik.values.patientOrNumberOrder}
                onChange={formik.handleChange}
                icon={<SearchIcon />}
                onIconClick={formik.submitForm}
              />

              <TextFieldNew
                placeholder="Médico responsável"
                style={{ maxWidth: '500px' }}
                name="doctorName"
                value={formik.values.doctorName}
                onChange={formik.handleChange}
                icon={<SearchIcon />}
                onIconClick={formik.submitForm}
              />

              <TextFieldNew
                placeholder="Convênio"
                style={{ maxWidth: '500px' }}
                name="healthInsurance"
                value={formik.values.healthInsurance}
                onChange={formik.handleChange}
                icon={<SearchIcon />}
                onIconClick={formik.submitForm}
              />
            </S.InputWrapper>
          </S.TabWrapper>

          <div>
            <S.Label>Data de criação do aviso</S.Label>
            <S.InputContainer>
              <S.InputCalendar>
                <TextField
                  mask={dateMask}
                  icon={<DateRange />}
                  iconPosition="right"
                  iconLocale="inside"
                  iconMargin="44px"
                  onIconClick={() => toggleCalendar('start')}
                  value={dateInputFormat(
                    moment(dates.start ?? '').toISOString()
                  )}
                />
                <S.StyledCalendar
                  show={showCalendar === 'start'}
                  onDateChange={(date) => changeDate(date as Date)}
                />
              </S.InputCalendar>
              <S.InputCalendar>
                <TextField
                  mask={dateMask}
                  icon={<DateRange />}
                  iconPosition="right"
                  iconLocale="inside"
                  iconMargin="44px"
                  onIconClick={() => toggleCalendar('end')}
                  value={dateInputFormat(
                    moment(dates.end ?? '')
                      .subtract(4, 'hours')
                      .toISOString()
                  )}
                />
                <S.StyledCalendar
                  right={true}
                  show={showCalendar === 'end'}
                  onDateChange={(date) => changeDate(date as Date)}
                />
              </S.InputCalendar>
            </S.InputContainer>

            <S.ProcessContainer>
              <S.Label>Situação do Processo</S.Label>
            </S.ProcessContainer>

            <S.ProcessContainer>
              <S.TagsContainer>
                <S.Tag className="on_time">No prazo</S.Tag>
                <S.Tag className="critic">Crítico</S.Tag>
                <S.Tag className="late">Atrasado</S.Tag>
              </S.TagsContainer>

              <S.InputContainer>
                <ButtonNew
                  variant="text"
                  outlined={true}
                  icon={<FilterIcon />}
                  onClick={toggleBoxNotifications}
                >
                  Filtrar
                </ButtonNew>
              </S.InputContainer>
            </S.ProcessContainer>
          </div>
        </S.PannelContainer>
        <Table
          columns={tableColumns}
          data={items.map((item: any) => ({
            patient_urgency: <> </>,
            patient_internal: <> </>,
            robotic: <> </>,
            hemodinamic: <></>,
            surgical_order_id: item.surgical_order.id,
            patient_name: item.patient.name,
            doctor_name: item.doctor.name,
            // main_surgery: getMainProcedureName(item?.surgical_order?.procedures),
            health_insurance: item.surgical_order.health_insurance.name,
            createdAt: item.createdAt,
            surgery_day: moment
              .utc(item.surgery_day)
              .format('DD/MM/YYYY - HH:mm'),
            scheduled_by_name: item.scheduled_by_name
            //interactions: item.interactions
            //situation: item.situation
            //created_by: item.created_by
          }))}
          // onPaginate={(pageNumber, pageSize) => {
          //   getSurgicalSchedules({
          //     hospitalId: currentHospitalId,
          //     pageNumber,
          //     pageSize
          //   })
          //   return Promise.resolve(undefined)
          // }}
          // count={paginationState?.totalItems}
          // rowsPerPage={paginationState?.itemsPerPage}
          onClick={() => console.log('test')}
        />
      </Container>
      <FilterDrawer boxIsOpen={boxIsOpen} setBoxIsOpen={setBoxIsOpen} />
    </>
  )
}

const FilterDrawer = ({ boxIsOpen, setBoxIsOpen }: any) => {
  const items = [
    {
      title: 'Pedidos com',
      content: (
        <>
          <S.CheckWrapper>
            <CheckboxNew
              name="urgency"
              labelFor={'Urgência'}
              label={'Urgência'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
            <CheckboxNew
              name="internal"
              labelFor={'Paciente internado'}
              label={'Paciente internado'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
            <CheckboxNew
              name="hemodynamic"
              labelFor={'Hemodinâmica'}
              label={'Hemodinâmica'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
            <CheckboxNew
              name="robotic"
              labelFor={'Robótica'}
              label={'Robótica'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
          </S.CheckWrapper>
        </>
      )
    },
    {
      title: 'OPME',
      content: (
        <>
          <S.CheckWrapper>
            <CheckboxNew
              name="withOpme"
              labelFor={'OPME sim'}
              label={'OPME sim'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
            <CheckboxNew
              name="noOpme"
              labelFor={'OPME não'}
              label={'OPME não'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
          </S.CheckWrapper>
        </>
      )
    },
    {
      title: 'Status do processo',
      content: (
        <S.CheckWrapper>
          <CheckboxNew
            name="ordersRequest"
            labelFor={'Solicitação de pedidos'}
            label={'Solicitação de pedidos'}
            // value={unit.unit_id}
            onCheck={() => console.log('check')}
            // checked={}
          />
          <CheckboxNew
            name="preSchedule"
            labelFor={'Pré-agendamento'}
            label={'Pré-agendamento'}
            // value={unit.unit_id}
            onCheck={() => console.log('check')}
            // checked={}
          />
          <CheckboxNew
            name="review"
            labelFor={'Revisão'}
            label={'Revisão'}
            // value={unit.unit_id}
            onCheck={() => console.log('check')}
            // checked={}
          />
          <CheckboxNew
            name="opmeCotation"
            labelFor={'Cotação de OPME'}
            label={'Cotação de OPME'}
            // value={unit.unit_id}
            onCheck={() => console.log('check')}
            // checked={}
          />
          <CheckboxNew
            name="waitingCotation"
            labelFor={'Aguardando cotação'}
            label={'Aguardando cotação'}
            // value={unit.unit_id}
            onCheck={() => console.log('check')}
            // checked={}
          />
          <CheckboxNew
            name="authorizationRequest"
            labelFor={'Solicitação de autorização'}
            label={'Solicitação de autorização'}
            // value={unit.unit_id}
            onCheck={() => console.log('check')}
            // checked={}
          />
          <CheckboxNew
            name="authorizationResponse"
            labelFor={'Retorno de autorização'}
            label={'Retorno de autorização'}
            // value={unit.unit_id}
            onCheck={() => console.log('check')}
            // checked={}
          />
          <CheckboxNew
            name="preScheduleConfirmation"
            labelFor={'Confirmação dos pré-agendamentos'}
            label={'Confirmação dos pré-agendamentos'}
            // value={unit.unit_id}
            onCheck={() => console.log('check')}
            // checked={}
          />
        </S.CheckWrapper>
      )
    },
    {
      title: 'Situação do processo',
      content: (
        <>
          <S.CheckWrapper>
            <CheckboxNew
              name="inTime"
              labelFor={'No prazo'}
              label={'No prazo'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
            <CheckboxNew
              name="critical"
              labelFor={'Crítico'}
              label={'Crítico'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
            <CheckboxNew
              name="late"
              labelFor={'Atrasado'}
              label={'Atrasado'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
          </S.CheckWrapper>
        </>
      )
    },
    {
      title: 'Interações',
      content: (
        <>
          <S.CheckWrapper>
            <CheckboxNew
              name="toResolve"
              labelFor={'A resolver'}
              label={'A resolver'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
            <CheckboxNew
              name="inProgress"
              labelFor={'Em andamento'}
              label={'Em andamento'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
            <CheckboxNew
              name="solved"
              labelFor={'Resolvidas'}
              label={'Resolvidas'}
              // value={unit.unit_id}
              onCheck={() => console.log('check')}
              // checked={}
            />
          </S.CheckWrapper>
        </>
      )
    }
  ]

  return (
    <S.BoxNotifications className={boxIsOpen ? '-open' : ''}>
      <S.BoxHeader>
        <button
          className="btn -back"
          type="button"
          onClick={() => setBoxIsOpen(false)}
        ></button>
        <h4>Filtro</h4>

        <ButtonNew variant="text" onClick={() => console.log('test')}>
          Limpar
        </ButtonNew>
      </S.BoxHeader>

      <S.BoxContent>
        <AccordionNew items={items} />

        <S.ButtonContainer>
          <ButtonNew variant="text" onClick={() => setBoxIsOpen(false)}>
            Cancelar
          </ButtonNew>

          <ButtonNew variant="default" onClick={() => console.log('test')}>
            Aplicar
          </ButtonNew>
        </S.ButtonContainer>
      </S.BoxContent>
    </S.BoxNotifications>
  )
}
